// app/lib/guest.ts
export function getGuestId(): string {
    if (typeof window === "undefined") return "";
    let guestId = localStorage.getItem("guestId");
    if (!guestId) {
      guestId = "guest_" + Math.random().toString(36).substr(2, 9);
      localStorage.setItem("guestId", guestId);
    }
    return guestId;
  }
  